import { render, staticRenderFns } from "./CashbackEcom.vue?vue&type=template&id=4d4a2bce&"
import script from "./CashbackEcom.vue?vue&type=script&lang=ts&"
export * from "./CashbackEcom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports